import { IHouse } from '../../types/newbuilding/house';
import { TApplicationState } from '../../types/redux';

export const housesDesktopSelector = (state: TApplicationState): IHouse[] => {
  return state.newbuilding.houses.filter(house => !!house.fromDeveloperPropsCount);
};

export const housesMobileSelector = (state: TApplicationState): IHouse[] => {
  return state.newbuilding.houses;
};
